module.exports = __webpack_public_path__ + "static/media/library.928394a0.PNG";